// extracted by mini-css-extract-plugin
export default {"layer":"layer--NuudX","itemWrapper":"itemWrapper--dxGwR"};